import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import ErrorBoundary from "@/components/ErrorBoundary";
import { initMotionPreference } from "@/lib/motionPreference";
import { initReadingMode } from "@/lib/readingMode";
import { bootstrapTallivoShadow } from "@/lib/commerce/tallivoShadowBootstrap";
import "./index.css";

initMotionPreference();
initReadingMode();
// Fire-and-forget; never blocks initial render.
void bootstrapTallivoShadow();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>,
);
